module.exports = __webpack_public_path__ + "static/media/Epcom.6ca52f1a.jpg";